module.exports = __webpack_public_path__ + "img/interactive-button.c96bfabd.svg";